import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeShow } from '../../features/filter/filterSlice';

const ProjectSingle = ({ projectName, colorClass }) => {
    const [checked, setChecked] = useState(true)
    const dispatch = useDispatch()
    const handleChange = (e) => {
        setChecked(!checked)
    }
    useEffect(() => {
        dispatch(changeShow({ projectName, show: checked }))
    }, [checked])
    return (
        <div className="checkbox-container">
            <input onChange={handleChange} type="checkbox" className={colorClass} defaultValue={checked} checked={checked} />
            <p className="label">{projectName}</p>
        </div>
    );
};

export default ProjectSingle;